import { createMapColorThemeContext } from "@app/shared/map-appearance/MapColorThemeContext";
import {
  CONTRACT_ENTITY_COLOR_THEME_DEFAULT,
  CONTRACT_ENTITY_COLOR_SLOT_DEFINITIONS,
  CONTRACT_ENTITY_COLOR_THEME_PRESETS,
} from "@app/overviews/market-expansion-dashboard/shared/ContractEntityColorThemeConstants";

const ContractEntityColorTheme = createMapColorThemeContext({
  defaultTheme: CONTRACT_ENTITY_COLOR_THEME_DEFAULT,
  localStorageKeySuffix: "market-expansion-contract-entity-color-theme",
  presetThemes: CONTRACT_ENTITY_COLOR_THEME_PRESETS,
  slotDefinitions: CONTRACT_ENTITY_COLOR_SLOT_DEFINITIONS,
});

export { ContractEntityColorTheme };
